module.exports = __webpack_public_path__ + "static/media/social-good-grey.2dd409a9.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/maker/social-good-grey.svg
 ** module id = 469
 ** module chunks = 0
 **/